// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"3f219ba6","271":"52b726ab","285":"5f1096f3"}[chunkId] + ".chunk.css";
};